import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Brain, SignOut, User as UserIcon, Buildings, Briefcase } from "@phosphor-icons/react";

export const Navbar = () => {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <header
            data-testid="app-navbar"
            className="sticky top-0 z-40 bg-white border-b border-slate-200"
        >
            <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="brand-link"
                    className="flex items-center gap-2"
                >
                    <div className="w-8 h-8 bg-slate-950 flex items-center justify-center">
                        <Brain size={20} color="#fff" weight="duotone" />
                    </div>
                    <span className="font-display text-xl tracking-tight">
                        Jobs<span className="text-blue-600">IQ</span>
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-6 text-sm">
                    <Link data-testid="nav-jobs" to="/jobs" className="hover:text-blue-600">
                        Find jobs
                    </Link>
                    {user?.role === "company" && (
                        <Link data-testid="nav-post" to="/post-job" className="hover:text-blue-600">
                            Post a job
                        </Link>
                    )}
                    {user?.role === "seeker" && (
                        <>
                            <Link data-testid="nav-chatbot" to="/chatbot" className="hover:text-blue-600">
                                AI screening
                            </Link>
                            <Link data-testid="nav-video" to="/video-interview" className="hover:text-blue-600">
                                Video interview
                            </Link>
                            <Link data-testid="nav-saved" to="/saved" className="hover:text-blue-600">
                                Saved
                            </Link>
                        </>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <Link
                                data-testid="nav-dashboard"
                                to="/dashboard"
                                className="hidden md:inline-flex items-center gap-2 text-sm"
                            >
                                {user.role === "company" ? (
                                    <Buildings size={18} />
                                ) : (
                                    <Briefcase size={18} />
                                )}
                                {user.name}
                            </Link>
                            <button
                                data-testid="logout-btn"
                                onClick={async () => {
                                    await logout();
                                    nav("/");
                                }}
                                className="text-sm px-3 py-1.5 border border-slate-300 hover:bg-slate-950 hover:text-white hover:border-slate-950 transition-colors"
                            >
                                <span className="inline-flex items-center gap-1.5">
                                    <SignOut size={16} />
                                    Log out
                                </span>
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                data-testid="nav-login"
                                to="/login"
                                className="text-sm hover:text-blue-600"
                            >
                                Sign in
                            </Link>
                            <Link
                                data-testid="nav-signup"
                                to="/register"
                                className="text-sm bg-slate-950 text-white px-4 py-2 hover:bg-blue-600 transition-colors inline-flex items-center gap-1.5"
                            >
                                <UserIcon size={16} weight="bold" />
                                Get started
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Navbar;
